import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="border-y border-electric/30 bg-surface py-16 sm:py-20" aria-labelledby="results-title" data-id="element-126" data-mp="28eg99jwmki7p">
      <div className="mx-auto max-w-6xl px-4" data-id="element-127" data-mp="2d79bo14mfegm">
        <SectionHeading id="results-title" data-id="element-128" data-mp="2h7s33u2lqiia">What <span className="text-electric" data-id="element-129" data-mp="2h6ql15n64vr2">professionals</span> say</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-130" data-mp="2m5laurjjzkko">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-electric/30 bg-background p-6 shadow-glow" data-id="element-131" data-mp="2r690p9w1pvdb" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-electric" aria-hidden="true" data-id="element-132" data-mp="3nfiuqilsqdk1" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-133" data-mp="3il4vg540jma3">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-electric/20 pt-4" data-id="element-134" data-mp="3do657xngzzh6">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-electric/60 bg-surface font-display text-sm font-extrabold text-electric" data-id="element-135" data-mp="38q4m5cq1o05p">
                  {initials}
                </span>
                <span data-id="element-136" data-mp="8q8r1lxetnm">
                  <b className="block text-sm text-foreground" data-id="element-137" data-mp="86ym72ip9k5">{name}</b>
                  <small className="text-xs text-muted" data-id="element-138" data-mp="3scj1ywudtmcq">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}